module.exports = __webpack_public_path__ + "static/img/51-2.78d5a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/51-2.jpg
// module id = 39eJ
// module chunks = 0